<ng-container>
    <button
        [type]="buttonType()"
        mat-button
        [disabled]="disabled()"
        [ngClass]="[fullWidth() ? 'full-width' : '', size(), type(), buttonVariant()]"
        (click)="onButtonClick()"
        [appIndeterminateButtonLoading]="isLoading()"
    >
        <span class="button-content">
            <app-svg-icon *ngIf="startIcon()" [iconPath]="startIcon() ?? ''" alt="start-icon" class="input-icon"> </app-svg-icon>
            <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
        </span>
    </button>
</ng-container>

<ng-template #buttonContent>
    <ng-content></ng-content>
</ng-template>
